import React, { useEffect, useMemo } from 'react'

export default function PhotoPreview({ open, src, filename, caption, onClose }) {
  useEffect(() => {
    if (!open) return
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => { document.body.style.overflow = prev }
  }, [open])

  const downloadName = useMemo(() => {
    try {
      const urlPath = (new URL(src, window.location.href)).pathname || ''
      const extMatch = urlPath.match(/\.([a-zA-Z0-9]+)$/)
      if (extMatch && extMatch[1]) return ((filename && filename.split('.').slice(0, -1).join('.')) || filename || 'image') + '.' + extMatch[1]
    } catch (e) { }
    // fallback: if filename already has an extension use it
    if (filename && filename.includes('.')) return filename
    // default to png
    return ((filename && filename) || 'image') + '.png'
  }, [src, filename])

  if (!open) return null

  async function handleDownload() {
    try {
      const res = await fetch(src, { mode: 'cors' })
      if (!res.ok) {
        // fallback: navigate
        window.location.href = src
        return
      }
      const blob = await res.blob()
      // determine extension
      let ext = ''
      const ct = res.headers.get('content-type') || ''
      if (ct) {
        const m = ct.split('/')[1]
        if (m) ext = m.split(';')[0]
      }
      if (!ext) {
        try {
          const p = (new URL(src, window.location.href)).pathname
          const m = p.match(/\.([a-zA-Z0-9]+)$/)
          if (m && m[1]) ext = m[1]
        } catch (e) {}
      }
      if (!ext) ext = 'png'

      // clean base filename
      let baseName = (filename || 'image')
      const dot = baseName.lastIndexOf('.')
      if (dot !== -1) baseName = baseName.substring(0, dot)
      baseName = baseName.replace(/[^a-zA-Z0-9_\-\.]/g, '_') || 'image'
      const finalName = `${baseName}.${ext}`

      const blobUrl = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = blobUrl
      a.download = finalName
      document.body.appendChild(a)
      a.click()
      setTimeout(() => {
        URL.revokeObjectURL(blobUrl)
        a.remove()
      }, 500)
    } catch (e) {
      // last-resort fallback
      window.location.href = src
    }
  }

  return (
    <div className="photo-modal" onClick={onClose}>
      <div className="photo-modal-content" onClick={e => e.stopPropagation()}>
        <div className="photo-modal-body">
          <img src={src} alt={filename} className="photo-modal-img" />
          
        </div>
        <div className="photo-modal-actions">
          <button onClick={handleDownload} className="photo-btn">ទាយយករូបថត</button>
          <button onClick={onClose} className="photo-btn photo-close">បោះបង់</button>
        </div>
      </div>
    </div>
  )
}
